import types from './mutation-types';

const actions = {
	flashMessage({ commit }, { message, type, nextPage }) {

		let pages = 0;

		if (nextPage === true) {
			pages = 1;
		}

		commit(types.ADD_FLASH_MESSAGE, {
			message: message,
			type: type,
			pages: pages
		});
	},
	nextPage({ commit }, { fromPage, toPage }) {
		commit(types.NEXT_PAGE);
	}
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/flash-messages/actions.js